import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const ImageContainer = styled.div`
	margin-top: 3rem;
`;

export const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 70%;
	text-align: center;
	gap: 2rem;
	padding-bottom: 2rem;

	@media ${Breakpoints.tablet} {
		width: 80%;
		padding-bottom: 3rem;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2rem;
`;
